import React from "react";
import { Col, Form, Row } from "react-bootstrap";

export default function SmsDropdown() {
  return (
    <div className="align-items-center rounded-3 p-4 bg-purple-gradient-darker-reverse px-5 mx-auto">
      <div className="ms-2">
        <span className="fs-4 fw-bold "> SMS</span>
      </div>
      <div className="text-secondary ms-2">
        Insert designated SMS number(s) here
      </div>
      <div className="ms-3 my-3">
        <div>
          <Form.Group as={Row} className="mb-3" controlId="originatorNumber">
            <Form.Label className="fw-bold">Originator Number/s :</Form.Label>
            <Col sm="10" className="p-2">
              <Form.Control type="text" />
            </Col>
          </Form.Group>
        </div>
        <div>
          <Form.Group as={Row} className="mb-3" controlId="reference">
            <Form.Label className="fw-bold">Reference:</Form.Label>
            <Col sm="10">
              <Form.Control type="text" />
            </Col>
          </Form.Group>
        </div>
      </div>
    </div>
  );
}
